import { proxy } from 'valtio';

import type { ConnectionStatus } from '@canvas/model';
import { type BoardSyncStatus } from '@canvas/model/network';

export const defaultConnectionStatus: ConnectionStatus = 'online';
export const defaultBoardSyncStatus: BoardSyncStatus = 'saved';

export interface CurrentConnectionStatus {
  connectionStatus: ConnectionStatus;
  boardSyncStatus: BoardSyncStatus;
}

export const currentConnectionStatus = proxy<CurrentConnectionStatus>({
  connectionStatus: defaultConnectionStatus,
  boardSyncStatus: defaultBoardSyncStatus,
});
